export class AssertExpressionPlainObject {
    public assertType: string;

    public trueExpression?: string;

    public uniqueExpressions?: string[];

    public existsExpression?: string;

    public ignoreNulls: boolean;

    public assertId: string;

    public filter?: string;

    public assertDescription?: string;
}
